(() => {
'use strict';
const dialogs = () => [...document.querySelectorAll('dialog[data-jp-info]')];
const triggers = new WeakMap();
const originalHosts = new Set([location.hostname, 'tempolorguitar.com', 'www.tempolorguitar.com', 'd3bqun-dw.myshopify.com']);
const routes = {
'/': '#top',
'/product': '#buy',
'/products/melo-d': '#buy',
'/collections/all': '#buy',
'/collections/generative-ai-guitar': '#buy',
'/app': '#app-showcase',
'/pages/app': '#app-showcase',
'/tutorials': '#tutorials',
'/pages/tutorials': '#tutorials',
'/support': '#jp-info-support',
'/pages/support': '#jp-info-support',
'/pages/contact': '#jp-info-support',
'/contact': '#jp-info-support',
'/about': '#jp-info-about',
'/pages/about': '#jp-info-about',
'/pages/about-us': '#jp-info-about',
'/pages/shipping': '#jp-info-support',
'/pages/shipping-policy': '#jp-info-support',
'/policies/shipping-policy': '#jp-info-support',
'/pages/returns': '#jp-policy-refund',
'/pages/warranty': '#jp-policy-refund',
'/pages/return-refund-policy': '#jp-policy-refund',
'/policies/refund-policy': '#jp-policy-refund',
'/pages/privacy-policy': '#jp-policy-privacy',
'/policies/privacy-policy': '#jp-policy-privacy',
'/pages/terms-of-use': '#jp-policy-terms',
'/policies/terms-of-service': '#jp-policy-terms',
'/cart': '#buy',
'/account': '#jp-info-support'
};
function normalizeLink(link) {
const raw = link.getAttribute('href');
if (!raw) return;
let url;
try { url = new URL(raw, location.href); } catch { return; }
if (/^https?:$/.test(url.protocol) && originalHosts.has(url.hostname) && !/^\/(cdn|apps)\//.test(url.pathname)) {
let target;
if (raw.startsWith('#')) target = raw;
else if (url.pathname === location.pathname && url.searchParams.get('view') === 'jp-original') target = url.hash || '#top';
else {
const path = url.pathname.replace(/^\/(ja|en|ko)(?:-[a-z]{2})?(?=\/|$)/i, '').replace(/\/$/, '') || '/';
target = url.hash === '#dealer-partnerships' ? '#jp-info-dealer' : routes[path] || '#jp-info-support';
}
if (raw !== target) link.setAttribute('href', target);
if (document.getElementById(target.slice(1))?.matches('dialog[data-jp-info]')) link.setAttribute('data-jp-info-open', '');
link.removeAttribute('target');
} else if (/^https?:$/.test(url.protocol) && !originalHosts.has(url.hostname)) {
link.setAttribute('target', '_blank');
link.setAttribute('rel', 'noopener noreferrer');
}
}
function normalize(root) {
if (root.matches?.('a[href]')) normalizeLink(root);
root.querySelectorAll?.('a[href]').forEach(normalizeLink);
root.querySelectorAll?.('.native-dialog > button[aria-label="Close"]').forEach(button => {
button.textContent = '×';
button.setAttribute('aria-label', '閉じる');
});
}
function closeMenus() {
document.querySelectorAll('.native-dialog:has(.menu-links)').forEach(dialog => dialog.close());
document.querySelectorAll('.store-nav details[open]').forEach(details => { details.open = false; });
}
function openInfo(dialog, trigger) {
const current = trigger.closest('dialog');
const returnTo = current ? triggers.get(current) : trigger;
dialogs().forEach(other => { if (other.open && other !== dialog) other.close(); });
closeMenus();
triggers.set(dialog, returnTo || trigger);
if (!dialog.open) dialog.showModal();
dialog.scrollTop = 0;
document.dispatchEvent(new Event('native:dialogchange'));
}
dialogs().forEach(dialog => {
dialog.classList.add('jp-info-dialog');
const title = dialog.querySelector('h2');
if (title) {
if (!title.id) title.id = dialog.id + '-title';
dialog.setAttribute('aria-labelledby', title.id);
}
dialog.addEventListener('close', () => {
document.dispatchEvent(new Event('native:dialogchange'));
const trigger = triggers.get(dialog);
if (trigger?.isConnected && !document.querySelector('dialog[open]')) trigger.focus({preventScroll:true});
});
dialog.addEventListener('click', event => {
if (event.target !== dialog) return;
const box = dialog.getBoundingClientRect();
if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
});
});
document.addEventListener('click', event => {
const close = event.target.closest?.('[data-jp-info-close]');
if (close) { close.closest('dialog')?.close(); return; }
const tutorial = event.target.closest?.('[data-jp-tutorial-start]');
if (tutorial) { document.querySelector('[data-tutorial-video]')?.click(); return; }
const link = event.target.closest?.('a[href]');
if (!link) return;
normalizeLink(link);
const href = link.getAttribute('href');
if (!href?.startsWith('#')) return;
const target = document.getElementById(href.slice(1));
if (!target) return;
if (target.matches('dialog[data-jp-info]')) {
event.preventDefault();
openInfo(target, link);
return;
}
const modal = link.closest('dialog[open]');
if (modal) modal.close();
closeMenus();
if (modal) {
event.preventDefault();
target.scrollIntoView({behavior:'instant', block:'start'});
history.replaceState(null, '', href);
}
}, true);
normalize(document);
new MutationObserver(records => records.forEach(record => {
if (record.type === 'attributes') normalizeLink(record.target);
record.addedNodes.forEach(node => { if (node.nodeType === 1) normalize(node); });
})).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
document.addEventListener('shopify:section:load', () => normalize(document));
})();
